export default "__VITE_ASSET__Z53yjkBR__"